import { createContext, useContext, useState } from "react";

const ChatBotContext = createContext();

export const useChatBot = () => {
  const context = useContext(ChatBotContext);
  if (!context) {
    throw new Error("useChatBot must be used within a ChatBotProvider");
  }
  return context;
};

export const ChatBotProvider = ({ children }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [language, setLanguage] = useState("english");
  const [messages, setMessages] = useState([
    {
      id: 1,
      type: "bot",
      message: "Hello! I'm your AI Career Assistant. How can I help you today?",
      timestamp: new Date(),
    },
  ]);

  const sendMessage = (message) => {
    const userMessage = {
      id: Date.now(),
      type: "user",
      message,
      timestamp: new Date(),
    };

    setMessages((prev) => [...prev, userMessage]);

    // Simulate AI response
    setTimeout(() => {
      const botResponse = {
        id: Date.now() + 1,
        type: "bot",
        message: generateBotResponse(message),
        timestamp: new Date(),
      };
      setMessages((prev) => [...prev, botResponse]);
    }, 1000);
  };

  const generateBotResponse = (userMessage) => {
    const responses = {
      resume:
        "I can help you improve your resume! Upload your current resume and I'll provide detailed feedback on formatting, content, and ATS optimization.",
      interview:
        "Let's practice for your interview! I can simulate common AI/ML interview questions and provide feedback on your answers.",
      jobs: "I can help you find the perfect job opportunities based on your skills and preferences. What type of role are you looking for?",
      skills:
        "Based on current market trends, I recommend focusing on these in-demand skills: Python, TensorFlow, PyTorch, AWS, and MLOps.",
      salary:
        "Based on your profile and target location, here's the expected salary range for your role...",
      default:
        "I understand you're asking about career guidance. I can help with resume reviews, interview preparation, job recommendations, and skill development. What would you like to focus on?",
    };

    const message = userMessage.toLowerCase();
    if (message.includes("resume")) return responses.resume;
    if (message.includes("interview")) return responses.interview;
    if (message.includes("job")) return responses.jobs;
    if (message.includes("skill")) return responses.skills;
    if (message.includes("salary")) return responses.salary;
    return responses.default;
  };

  const value = {
    isOpen,
    setIsOpen,
    language,
    setLanguage,
    messages,
    sendMessage,
  };

  return (
    <ChatBotContext.Provider value={value}>{children}</ChatBotContext.Provider>
  );
};
